/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from 'react'
import { contentByLocale, locales } from '../content/data'
import type { Locale, PortfolioContent } from '../content/types'

interface LocaleContextValue {
  locale: Locale
  setLocale: (locale: Locale) => void
  content: PortfolioContent
}

const LocaleContext = createContext<LocaleContextValue | null>(null)

function getInitialLocale(): Locale {
  const stored = window.localStorage.getItem('portfolio-locale')
  return locales.includes(stored as Locale) ? (stored as Locale) : 'en'
}

export function LocaleProvider({ children }: { children: ReactNode }) {
  const [locale, setLocale] = useState<Locale>(getInitialLocale)

  useEffect(() => {
    window.localStorage.setItem('portfolio-locale', locale)
    document.documentElement.lang = locale
  }, [locale])

  const value = useMemo(() => ({ locale, setLocale, content: contentByLocale[locale] }), [locale])

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
}

export function useLocale() {
  const value = useContext(LocaleContext)
  if (!value) throw new Error('useLocale must be used inside LocaleProvider')
  return value
}
